import { css, html } from "../helpers/webComponents";

const styles: string = css`
    :host {
        height: 100%;
        display: flex;
        background-color: rgba(0, 0, 0, 0.75);
        justify-content: center;
        align-items: center;
    }
`;

export class ModalFuseboxComponent extends HTMLElement {
    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });

        this.render();
    }

    private render(): void {
        if (!this.shadowRoot) {
            return;
        }

        const element: HTMLElement = this.renderFusebox();

        this.shadowRoot.firstChild?.remove();
        this.shadowRoot.append(element);
    }

    private renderFusebox(): HTMLElement {
        const element: HTMLElement = html`
        <div>
            <style>
                ${styles}
            </style>

            <div>
                <game-fuse></game-fuse>
            </div>
        </div>
        `;

        return element;
    }
}
